/**
 * Path Calculation Service
 * Provides pure function utilities for path distance calculations
 */


export const formatDistance = (distance) => {
  return parseFloat(distance).toFixed(2);
};


export const calculatePathDistance = (path, locations) => {
  if (!path || path.length < 2 || !locations || locations.length === 0) {
    return 0;
  }

  let totalDistance = 0;
  for (let i = 0; i < path.length - 1; i++) {
    const currentId = path[i];
    const nextId = path[i + 1];
    
    const currentLocation = locations.find(loc => loc.id === currentId);
    const nextLocation = locations.find(loc => loc.id === nextId);
    
    if (currentLocation && nextLocation) {
      const distance = manhattanDistance(
        currentLocation.latitude, 
        currentLocation.longitude, 
        nextLocation.latitude, 
        nextLocation.longitude
      );
      totalDistance += distance;
    }
  }
  
  return totalDistance;
};


export const manhattanDistance = (lat1, lon1, lat2, lon2) => {
  // Convert degree differences to approximate kilometers
  // 1 degree latitude ≈ 111 km
  // 1 degree longitude ≈ 111 km (simplified calculation)
  const latDiff = Math.abs(lat2 - lat1);
  const lonDiff = Math.abs(lon2 - lon1);
  
  // Convert to kilometers using degree-to-km conversion
  const latKm = latDiff * 111.0;
  const lonKm = lonDiff * 111.0;
  
  // Manhattan distance in kilometers
  const manhattanDist = latKm + lonKm;
  
  return manhattanDist;
}; 